<template>
    <li class="aufgabe" :class="{ done: done }">
        <!-- Zustand nie nur ueber Farbe: Ring/Haken plus das Wort. -->
        <span class="marke" aria-hidden="true">
            <svg v-if="done" viewBox="0 0 16 16"><path d="M3.5 8.5l3 3 6-7" /></svg>
        </span>
        <span class="text">{{ task.label }}</span>
        <span v-if="done" class="status">erledigt</span>
        <span v-else class="nur-vorlesen">offen</span>
    </li>
</template>

<script>
export default {
    props: {
        task: Object,
        done: Boolean
    }
}
</script>

<style scoped>
/* Eine Zeile pro Aufgabe. Offen ist neutral; Farbe kommt erst mit
   «erledigt» dazu (Oliv = richtig, wie ueberall in der App). */
.aufgabe {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 0.75rem;
    min-height: 2.75rem;
    box-sizing: border-box;
    padding: 0.5rem 0.75rem;
    color: var(--zs-tinte);
    background: #ffffff;
    border: 1px solid var(--zs-rahmen);
    border-radius: var(--zs-ecke);
    transition: background-color 0.25s ease-out, border-color 0.25s ease-out;
}

.marke {
    display: grid;
    place-items: center;
    width: 1.25rem;
    height: 1.25rem;
    border: 2px solid var(--zs-grau);
    border-radius: 50%;
    box-sizing: border-box;
}

.marke svg {
    width: 0.9rem;
    height: 0.9rem;
    fill: none;
    stroke: #ffffff;
    stroke-width: 2.2;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.text {
    font-size: 0.95rem;
    line-height: 1.4;
}

.status {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--zs-oliv);
}

.done {
    background: var(--zs-oliv-hell);
    border-color: rgba(85, 107, 47, 0.35);
}

.done .marke {
    background: var(--zs-oliv);
    border-color: var(--zs-oliv);
}

@media (prefers-reduced-motion: reduce) {
    .aufgabe {
        transition: none;
    }
}
</style>
